import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Alert, Form, Row, Spinner } from 'react-bootstrap';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { updateTermsAndConditions } from '../../../Common/data/updateTermsAndConditions';
import { getTermsAndConditions, TermsAndConditions as TermsData } from '../../../Common/data/termsAndCondtions'; 

type EditorType = {
    getData: () => string;
};

const TermsAndConditions: React.FC = () => {
    
    const [formData, setFormData] = useState({
        updatedBy: 'Admin',
        pageStatus: '2',
        pageID: 'c10c8fbe-594b-4f52-89b1-f3ad86d12d64',
        pageName: "Terms And Conditions",
        pageContent: '',
    });
    const [successAlert, setSuccessAlert] = useState(false);
    const [termsData, setTermsData] = useState<TermsData | undefined>(undefined);
    const [processing, setProcessing] = useState(false); // State to track processing

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setProcessing(true); // Set processing to true when starting the request

        try {
            const updatedData = {
                ...formData,
                pageContent: formData.pageContent,
            };

            console.log('updated Data:', updatedData);

            await updateTermsAndConditions(updatedData);

            console.log('Terms and Conditions details updated successfully!');
            setSuccessAlert(true);

            // Hide the success alert after 3 seconds
            setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
        } catch (error: any) {
            console.error('Error updating Terms and Conditions details:', error.message);
        } finally {
            setProcessing(false); // Set processing to false after request completes
        }
    };

    const fetchTermsDetails = async () => {
        try {
            const data = await getTermsAndConditions();
            setTermsData(data);
        } catch (error: any) {
            console.error('Error fetching Terms and Conditions details:', error.message);
        }
    };

    useEffect(() => {
        // Fetch Terms and Conditions details when the component mounts
        fetchTermsDetails();
    }, []); // Empty dependency array ensures the effect runs only once

    return (
        <Card>
            <Card.Header>
                <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                            <div className="avatar-title rounded-circle custom-bg-light custom-text-primary fs-20">
                                <i className="bi bi-file-earmark-text"></i>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-1">Terms and Conditions</h5>
                        <p className="text-muted mb-0">Fill all information below.</p>
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col lg={12}>
                        <div className="mb-3">
                            <Form.Label htmlFor="terms-and-conditions-input-description">Content</Form.Label>

                            {/* Replace Form.Control with CKEditor */}
                            <CKEditor
                                editor={ClassicEditor}
                                data={termsData?.pageContent || ''}
                                onReady={(editor: any) => {
                                    // You can store the "editor" and use when it is needed.
                                }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>, editor: any) => {
                                    if (editor) {
                                        const content: string = editor.getData();
                                        setFormData({ ...formData, pageContent: content });
                                    }
                                }}
                            />

                            <div className="invalid-feedback">Please enter Terms and Conditions content.</div>
                        </div>
                    </Col>
                </Row>

                {successAlert && (
                    <Alert variant="success" onClose={() => setSuccessAlert(false)} dismissible>
                        <p>Terms and Conditions details updated successfully!</p>
                    </Alert>
                )}
                <Button type="submit" variant="primary" onClick={handleSubmit}>
                    {processing ? <Spinner animation="border" size="sm" className="me-2" /> : null} Save Changes
                </Button>
            </Card.Body>
        </Card>
    );
};

export default TermsAndConditions;
